import { useDispatch } from "react-redux";
import { CameraIcon, FileUploadIcon } from "../../../components/icons/SvgIcons";
import SubirFotoLicencia from "./subirFotoLicencia";
import { useState } from "react";
import { limpiarFotoLicencia } from "../../../redux/actions";
import ErrorModal from "../../../components/modals/errorModal";

function OpcionesFotoLicencia({ closeOpcionesFotoLicencia, openTakeFotoLicencia, openConfirmarDatosLicencia, openOpcionesFotoLicencia }) {
  const dispatch = useDispatch();
  const [errorModal, setErrorModal] = useState({ show: false, message: "" });
  const openErrorModal = (message) => setErrorModal({ show: true, message });
  const closeErrorModal = () => setErrorModal({ show: false, message: "" });

  const [imagen, setImagen] = useState(null);

  const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
  const [preview, setPreview] = useState(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (!file) return; // Si no hay archivo, no hacer nada

    // Validar tipo de archivo (solo imágenes)
    if (!file.type.startsWith("image/")) {
      openErrorModal("Por favor, selecciona un archivo de imagen válido.");
      return;
    }

    if (file.size > MAX_FILE_SIZE) {
      openErrorModal("La imagen es demasiado grande. Selecciona una de menos de 5MB.");
      return;
    }


    // Crear vista previa
    const objectUrl = URL.createObjectURL(file);
    setPreview(objectUrl);

    // Guardar el archivo en el estado
    setImagen(file);

  };

  const handleBack = () => {
    setImagen(null);
    openOpcionesFotoLicencia()
  };


  //----Limpiar store si la licencia se sube sin foto-----//
  const handlePostearSinFoto = async () => {
    await dispatch(limpiarFotoLicencia()); // Limpiar foto del store
    openConfirmarDatosLicencia()
  };


  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 "
      onClick={closeOpcionesFotoLicencia} /* Cierra al hacer clic fuera */
    >
      {!imagen ? (
        <div
          className="relative w-[20rem] sm:w-[30rem] px-1 py-1 bg-white rounded-xl flex flex-col justify-center  gap-6 mx-5 overflow-y-auto my-[2rem]"
          onClick={(e) =>
            e.stopPropagation()
          } /* Evita que el clic dentro lo cierre */
        >
          <button
            onClick={closeOpcionesFotoLicencia}
            className="absolute top-1 right-2 text-gray-400 hover:text-gray-600"
          >
            ✕
          </button>
          <div className="my-[1rem]  flex-col justify-start items-start gap-3 inline-flex mx-[1rem]">
            <button
              onClick={openTakeFotoLicencia}
              className="self-stretch px-4 py-7 bg-white rounded-lg border border-[#c5dfff] justify-start items-center gap-2.5 inline-flex"
            >
                <div className="w-[49px] h-[49px] relative">
                  <CameraIcon className="size-18 stroke-[#0477ad]" />
                </div>
              <div className="flex-col justify-start items-start gap-1 inline-flex">
                <div className="text-[#0477ad] text-lg font-bold font-inter">
                  Tomar foto
                </div>
                <div className="text-[#687073] text-sm font-normal font-inter">
                  Capturar una foto de la licencia a ingresar
                </div>
              </div>
            </button>
            <label
              for="file-upload"
              htmlFor="file-upload"
              className="self-stretch px-4 py-7 bg-white rounded-lg border border-[#c5dfff] justify-start items-center gap-2.5 inline-flex cursor-pointer"
            >
              <div className="w-[49px] h-[49px] relative">
                <FileUploadIcon className="size-18 stroke-[#0477ad]" />
              </div>
              <div className="flex-col justify-start items-start gap-1 inline-flex">
                <div className="text-[#0477ad] text-lg font-bold font-inter">
                  Subir foto
                </div>
                <div className="text-[#687073] text-sm font-normal font-inter">
                  Cargar una foto del dispositivo
                </div>
              </div>

              <input
                type="file"
                id="file-upload"
                className="hidden"
                onChange={handleFileChange}
              />
            </label>
            <button
              onClick={handlePostearSinFoto}
              className="self-stretch px-4 py-7 bg-white rounded-lg border border-[#c5dfff] justify-start items-center gap-2.5 inline-flex"
            >
              <div className="w-[49px] h-[49px] relative">
                <FileUploadIcon className="size-18 stroke-[#0477ad]" />
              </div>
              <div className="flex-col justify-start items-start gap-1 inline-flex">
                <div className="text-[#0477ad] text-lg font-bold font-inter">
                  Saltar este paso
                </div>
                <div className="text-[#687073] text-start text-sm font-normal font-inter">
                  Capturar una foto mas tarde
                </div>
              </div>
              <div className="p-0.5 justify-start items-center gap-2.5 flex" />
            </button>
          </div>
        </div>
      ) : (
        <SubirFotoLicencia imagen={imagen} preview={preview} handleBack={handleBack} openConfirmarDatosLicencia={openConfirmarDatosLicencia} />
      )}
      {errorModal.show && (
        <ErrorModal
          closeErrorModal={closeErrorModal}
          message={errorModal.message}
        />
      )}
    </div>

  );
}

export default OpcionesFotoLicencia;
